export const routes = [
  {
    path: '/',
    title: 'Audit Vector — независимый аудит и инвентаризация в Казахстане',
    description:
      'Аудит финансовой отчётности, инвентаризация ТМЗ и основных средств. Audit Vector: Астана и промышленные объекты по всему Казахстану.',
  },
  {
    path: '/services/',
    title: 'Услуги — Audit Vector',
    description:
      'Аудит по МСФО и НСФО, инвентаризация ТМЗ, проверка основных средств и аналитические отчёты.',
  },
  {
    path: '/about/',
    title: 'О компании — Audit Vector',
    description:
      'ТОО Audit Vector: независимый аудит, государственная лицензия № 24032816, членство в Союзе аудиторов Казахстана.',
  },
  {
    path: '/cases/',
    title: 'Проекты — Audit Vector',
    description:
      'Опыт Audit Vector: инвентаризация KATCO в 2022–2024 годах и проверка активов Уральского завода «Зенит».',
  },
  {
    path: '/contact/',
    title: 'Контакты — Audit Vector',
    description:
      'Обсудите проект аудита и инвентаризации. info@auditvector.kz. Астана, ЖК Тельман, ул. Аккемер 12/3.',
  },
];
